<template>
    <div v-if="showBanner" id="switch-to-old-banner" class="banner">
        <div class="container flex flex-wrap flex-md-nowrap">
            <span>
                <strong>
                    <a href="/cookies">
                        This site uses cookies.
                    </a>
                </strong>
                Some are necessary for core functionality but others are used for analytics and measuring campaign performance.
            </span>
            <span class="flex justify-between mt-2 mt-md-0">
                <a
                    id="close-banner-accept" href="#" class="btn btn-secondary btn-sm"
                    role="button" aria-label="Close banner" @click="cookieAccept"
                >
                    <span>
                        <font-awesome-icon
                            icon="fa-solid fa-check" aria-hidden="true"
                        >
                        </font-awesome-icon>
                    </span>
                    I'm fine with this
                </a>
                <a
                    id="close-banner-reject" href="#" class="btn btn-secondary btn-sm"
                    role="button" aria-label="Close banner" @click="cookieReject"
                >
                    <span>
                        <font-awesome-icon
                            icon="fa-solid fa-xmark" aria-hidden="true"
                        >
                        </font-awesome-icon>
                    </span>
                    Reject non-essential cookies
                </a>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BottomBanner',
    data() {
        return {
            showBanner: false,
        };
    },
    created() {
        this.showBanner = document.cookie.indexOf('CookieBannerShown') === -1;

        if (document.cookie.indexOf('CookiesAccepted') !== -1 && this.getCookieAccepted() === 'true') {
            this.loadTrackers();
        }
    },
    methods: {
        cookieAccept(ev) {
            ev.preventDefault();
            this.showBanner = false;
            document.cookie = 'CookieBannerShown=true;Max-Age=31536000';
            document.cookie = 'CookiesAccepted=true;Max-Age=31536000';
            this.loadTrackers();
            return false;
        },
        cookieReject(ev) {
            ev.preventDefault();
            this.showBanner = false;
            document.cookie = 'CookieBannerShown=true;Max-Age=31536000';
            document.cookie = 'CookiesAccepted=false;Max-Age=31536000';
            return false;
        },
        getCookieAccepted() {
            const value = `; ${document.cookie}`;
            const parts = value.split('; CookiesAccepted=');
            if (parts.length === 2) return parts.pop().split(';').shift();
            return 'false';
        },
        loadTrackers() {
            const gaTrackingId = document.querySelector('meta[name=brand-ua-tracking-id]').content;
            /* eslint-disable */
            ((w, d, t, r, u) => {
                let f,
                    n,
                    i;
                w[u] = w[u] || [], f = function () {
                    const o = { ti: ' 36004960' };
                    o.q = w[u];
                    if (w.UET) w[u] = new w.UET(o) || [];
                    w[u].push('pageLoad');
                },
                    n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () {
                    const s = this.readyState;
                    s && s !== 'loaded' && s !== 'complete' || (f(), n.onload = n.onreadystatechange = null);
                },
                    i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i);
            })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
            /* eslint-enable */
            const gaScript = document.createElement('script');
            gaScript.type = 'text/javascript';
            gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`;
            document.head.appendChild(gaScript);
        },
    },
};
</script>
